'use strict';
import {filter, from, mergeMap, of, share, take, tap} from 'rxjs';
import AbstractChart from './abstract-chart';

export default class PopularityDiff extends AbstractChart {
  constructor(targetId, filters = []) {
    super();

    this.filterSubject.next(filters);
    this.subscribes = [];
    this.main$ = of(targetId).pipe(
      mergeMap(key => from(['popularity', 'score'].map(type => $(`#${key}-${type}`)))),
      filter(_ => _.length > 0),
      share()
    );
    // filter設定
    this.subscribes.push(this.main$.pipe(take(1), tap(($base) => {
      const $button_tmpl = $.templates('#statistics-filter-button');
      const $filter_block = $(document.querySelector(`#${targetId}-filters`));
      this.renderFilterButtons($filter_block, $button_tmpl);
    })).subscribe());
    this.render$ = this.main$.pipe(
      mergeMap(($base) => {
        const $container = $('.container', $base);
        const endpoint = $base.data('endpoint');
        const $item_tmpl = $.templates(`#statistics-popularity-diff-item-tmpl`);

        return this.filterSubject.pipe(
          mergeMap(async(filters) => {
            const params = new URLSearchParams(this.toParamFilter(filters));
            return [await (await fetch(endpoint + `&${params}`)).json(), params];
          }),
          tap(([response, params]) => {
            const items = response.items.slice(0, 5);
            $container.empty();
            if (response.items.length === 0 || response.is_lt_10_title || response.is_complete_title_lt_5) {
              $base.addClass('nodata');

              const malVsScoreElements = $('.mal-vs-popularity');
              const chartRootElements = $('.chart-root.nodata', malVsScoreElements);
              if (chartRootElements && chartRootElements.length === 2) {
                $('.sp-toggle-filter-btn', malVsScoreElements).prop('disabled', true);
              }
            }
            if (response.result) {
              $container.append($item_tmpl.render({...items, ...response, params}));
            }
            $('.block-loading', $base).addClass('hidden');
          }));
      })
    ).subscribe();
    this.subscribes.push(this.main$);
    this.subscribes.push(this.render$);
  }
}

$(function() {
  new PopularityDiff('statistics-anime-popularity-diff', [
    {key: 'dated_at', value: 'wrap_up_year', label: 'Wrap-Up', type: 'check', position: 'filter'},
    {key: 'dated_at', value: 'past_year', label: 'Past Year', type: 'check', position: 'filter'},
    {key: 'dated_at', value: 'last_season', label: 'Last Season', type: 'check', position: 'mal_filter'},
    {key: 'dated_at', value: 'custom', label: 'Custom Time', type: 'picker', position: 'mal_filter'},
  ]);

  new PopularityDiff('statistics-manga-popularity-diff', [
    {key: 'dated_at', value: 'wrap_up_year', label: 'Wrap-Up', type: 'check', position: 'filter'},
    {key: 'dated_at', value: 'past_year', label: 'Past Year', type: 'check', position: 'filter'},
    {key: 'dated_at', value: 'custom', label: 'Custom Time', type: 'picker', position: 'mal_filter'},
  ]);
});
